var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userId || _vm.emptyText)?_c('div',{staticClass:"user-details"},[_vm._v(" "+_vm._s(!_vm.userId ? _vm.emptyText : _vm.userLookup[_vm.userId].name + ' (' + _vm.userLookup[_vm.userId].email + ')')+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }